import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";

export default function PaymentsFinTechLicenseMauritius() {

    return (
        <main className='main'>

            <IntroSection
                title="Payments & FinTech License – Mauritius"
                subtitle="Launch PSPs, E-Money Institutions & FinTech Platforms in a Tier-1 Jurisdiction"
                description="Mauritius provides a credible, regulator-approved framework for Payment Service Providers (PSPs), E-Money Issuers (EMIs), and FinTech innovators. Its Payment Intermediary Services (PIS) License is widely used for PSPs, remittance providers, and merchant acquiring firms, while the E-Money Issuer License enables fintechs to launch digital wallets, prepaid cards, and e-money ecosystems."
                badges={[
                    "PSPs",
                    "E-Money Issuers",
                    "Remittance Firms",
                    "FinTech Sandbox"
                ]}
                buttonText="Request a Mauritius Payments Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/gibraltar-crypto-dlt-license-hero.png")}
                imageAlt="Mauritius Payments & FinTech"
            />

            <section className='section'>
                <div className='container'>
                <WhySection
                    title='Why Choose Mauritius for Payments & FinTech?'
                    blocks={
                        [
                            {
                                items:
                                    [
                                        {
                                            title: "Tier-1 Recognition",
                                            text: "FSC & BoM regulated."
                                        },
                                        {
                                            title: "Multiple Options",
                                            text: "PSPs, EMIs, MSBs, and fintech sandbox available."
                                        },
                                        {
                                            title: "Gateway to Africa & India",
                                            text: "Ideal for cross-border remittances."
                                        },
                                        {
                                            title: "Tax Treaties",
                                            text: "Access to 40+ Double Taxation Treaties."
                                        },
                                        {
                                            title: "Innovation-Friendly",
                                            text: "Fintech sandbox for crypto, DeFi, and payments."
                                        }
                                    ]
                            }
                        ]
                    }
                />

                <InfoBlocks
                    title="Types of FinTech & Payment Licenses"
                    blocks={[
                        {
                            title: "Payment Intermediary Services (PIS) License",
                            items: [
                                { text: "Authorizes payment processing, merchant acquiring, e-commerce payments." },
                                { text: "Used by PSPs, remittance startups, and card processors." },
                                { text: "Capital Requirement: USD 100,000." }
                            ]
                        },
                        {
                            title: "E-Money Issuer (EMI) License",
                            items: [
                                { text: "For digital wallets, prepaid cards, stored value, and mobile money." },
                                { text: "Popular with fintechs expanding in Africa & Asia." },
                                { text: "Capital Requirement: USD 250,000+." }
                            ]
                        },
                        {
                            title: "Money Services Business (MSB) License",
                            items: [
                                { text: "Covers remittance and currency exchange services." },
                                { text: "Often combined with PIS or EMI for hybrid payment models." }
                            ]
                        },
                        {
                            title: "FinTech Sandbox License",
                            items: [
                                { text: "Allows innovative firms (crypto, blockchain, AI finance, DeFi) to test under regulatory supervision." },
                                { text: "Flexible entry for startups not fitting traditional models." }
                            ]
                        }
                    ]}
                />

                <LocationTimeline
                    title="Capital & Requirements"
                    item={
                        [
                            {
                                title: "PIS License",
                                text: "USD 100,000 minimum."
                            },
                            {
                                title: "EMI License",
                                text: "USD 250,000+."
                            },
                            {
                                title: "MSB License",
                                text: "USD 100,000–150,000."
                            },
                            {
                                title: "Entity Requirement",
                                text: "Mauritius Global Business Company (GBC) required."
                            },
                            {
                                title: "Resident Presence",
                                text: "Local office, resident director, and compliance officer."
                            },
                            {
                                title: "AML/KYC",
                                text: "Strict FATF-aligned obligations."
                            }
                        ]
                    }
                />

                <ServiceCards
                    title='Benefits of a Mauritius Payments License'
                    services={
                        [
                            {
                                title: "Tier-1 Credibility",
                                text: "Respected regulator & legal system."
                            },
                            {
                                title: "Multiple Models",
                                text: "PSP, EMI, MSB, fintech sandbox options."
                            },
                            {
                                title: "Banking Access",
                                text: "Easier than unlicensed offshore PSPs."
                            },
                            {
                                title: "Scalable",
                                text: "Start with PIS and expand to EMI or MSB."
                            },
                            {
                                title: "Crypto-Friendly",
                                text: "PSPs may integrate with digital asset services."
                            }
                        ]
                    }
                />

                <FeatureCards
                    title='Licensing Process'
                    features={
                        [
                            {
                                title: "Pre-Application Consultation",
                                text: "Choose PSP, EMI, MSB, or sandbox model."
                            },
                            {
                                title: "Entity Incorporation",
                                text: "Register a Mauritius GBC."
                            },
                            {
                                title: "Application Preparation",
                                text: "Prepare AML/KYC manuals, business plan, and financials."
                            },
                            {
                                title: "Regulator Review",
                                text: "FSC and/or BoM evaluate the application."
                            },
                            {
                                title: "Approval & License Issuance",
                                text: "Typically completed in 4–6 months."
                            }
                        ]
                    }
                />

                <TimelineSection
                    title='Timeline & Costs'
                    items={[
                        {
                            name: "Timeline",
                            duration: "4–6 months",
                        },
                        {
                            name: "Setup Costs",
                            description: "From USD 60,000+ (legal, compliance, advisory)",
                        },
                        {
                            name: "Capital Requirement",
                            description: "USD 100k–250k depending on license",
                        },
                        {
                            name: "Annual Costs",
                            description: "FSC/BoM fees, audits, compliance reporting",
                        },
                    ]}
                />

                <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Specialists in PSP, EMI, and fintech licensing" },
                                { text: "End-to-end support: GBC setup, FSC filing, compliance frameworks" },
                                { text: "Introductions to banks, card issuers, and payment processors" },
                                { text: "Guidance for crypto-integrated fintechs" },
                                { text: "Comparative analysis: Mauritius vs Cyprus vs Seychelles vs Panama" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a regulated crypto business in Latin America?"
                        description="Panama offers crypto licensing under Law 697, with low barriers, tax advantages, and global flexibility."
                        buttonText="Book a Panama Crypto License Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is the difference between a PIS and an EMI?",
        content: [
            { type: "answer", text: "PIS = payment processor/PSP.\nEMI = digital money issuer (wallets, prepaid, mobile money)." },
        ],
    },
    {
        question: "What’s the capital requirement?",
        content: [
            { type: "answer", text: "PIS: USD 100k.\nEMI: USD 250k." },
        ],
    },
    {
        question: "Can Mauritius PSPs integrate crypto?",
        content: [
            { type: "answer", text: "Yes — through hybrid PSP + VASP models under FSC oversight." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "4–6 months." },
        ],
    },
    {
        question: "Why choose Mauritius over Seychelles?",
        content: [
            { type: "answer", text: "Mauritius offers Tier-1 reputation and treaty access, while Seychelles is lower-cost but less globally recognized." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We launched a PSP in Mauritius targeting Africa-India trade flows. Offshore Advisory managed FSC approval and compliance.",
        author: "Rahul S.",
        role: "FinTech CEO"
    },
    {
        quote: "Mauritius EMI licensing gave us credibility with banks and card issuers. Offshore Advisory guided us through FSC filings.",
        author: "Elena K.",
        role: "Payments Entrepreneur"
    }
];
